
    import { Component, Vue, Prop, Watch } from 'vue-facing-decorator';
    import { removeMdiBracketToIcon } from '@/mdi';

    @Component({
        emits: ['changed', 'save'],
    })
    export default class EditLocation extends Vue {
        @Prop({ default: null }) public location: any;
        @Prop({ default: null }) public model: any;
        @Prop({ default: null }) public scenario: any;

        private removeMdiBracketToIcon = removeMdiBracketToIcon;
        private modalShow = false;
        private valid = false;
        private menu = false;
        // Getter, not a class-field array: a field initializer's arrow captures the raw
        // (pre-proxy) `this`, which has no `$t`, so the rule threw "this.$t is not a function"
        // on validation. A getter resolves `this` to the component proxy at access time.
        private get nameRules(): (any)[] {
            return [(v: string) => !!v || this.$t('message.nameRequired')];
        }
        
        private mounted() {
            document.addEventListener("keydown", (e) => {
                if (e.key === "Escape") {
                    if (this.modalShow) this.close();
                }
            });
        }

        private changed() {
            this.$emit('changed', this.location?.locationProperties);
        }
        
        @Watch('location')
        private onLocationChanged(value: any) {
            if (value) this.modalShow = true; else this.modalShow = false;
            this.menu = false; // reset the save dropdown when the dialog (re)opens/closes
            if (this.location != null) {

                this.location.locationProperties.forEach(function (locationProperty: any) {
                    if (locationProperty.dataType == 2) {
                        locationProperty["percentageValue"] = locationProperty.numberValue * 100;
                    }
                });
            }
            this.changed();
        }

        private async save(scenarioCreation: any) {
            this.menu = false; // close the save dropdown (it has close-on-content-click=false)
            // Vuetify 3: form.validate() is async and returns { valid, errors }. On failure it
            // marks invalid inputs with .v-input--error; scroll the first one into view (Vue 2
            // did this synchronously).
            const form = this.$refs.form as any;
            const { valid } = await form.validate();
            if (!valid) {
                this.$nextTick(() => {
                    const firstError = (form.$el as HTMLElement)?.querySelector('.v-input--error');
                    if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                });
                return;
            }
            this.location['scenarioCreation'] = scenarioCreation;
            this.location.locationProperties.forEach(function (locationProperty: any) {
                if (locationProperty.dataType == 2) locationProperty.numberValue = locationProperty.percentageValue / 100;
            });
            this.$emit('save', this.location);
        }

        private async close() {
            const res = await this.$confirm(String(this.$t('message.confirmClose')), { buttonTrueText: String(this.$t('message.yes')), buttonFalseText: String(this.$t('message.no')) });
            if (res) { this.modalShow = false }
        }

        private toggleMenu() {
            this.menu = !this.menu;
        }

        private groupBy(list :any, keyGetter:any) {
            const map = new Map();
            list.forEach((item: any) => {
                const key = keyGetter(item);
                const collection = map.get(key);
                if (!collection) {
                    map.set(key, [item]);
                } else {
                    collection.push(item);
                }
            });
            return map;
        }
        
        private get locationPropertiesBySection() {
            return this.groupBy(this.location.locationProperties, function (locationProperty: any) { return locationProperty.sectionTitle } );
        }

        private get selectableLocationGroups() {
            const _self = this;
            return this.model.locationGroups.filter(function (locationGroup: any) {
                return locationGroup.selectable || _self.location.locationGroup == locationGroup;
            });
        }
    }
